module.exports = __webpack_public_path__ + "static/img/sj_bg.2ae9b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_bg.png
// module id = GNrQ
// module chunks = 1